var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelfHost = function SvgSelfHost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 28,
    viewBox: "0 0 18 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0V28H10V20H8V28H0V0H18ZM16 2H2V26H6V18H12V26H16V2ZM6 8H4V4H6V8ZM10 8H8V4H10V8ZM6 14H4V10H6V14ZM10 14H8V10H10V14ZM14 8H12V4H14V8ZM14 14H12V10H14V14Z",
    fill: "black",
    fillOpacity: 0.54
  })));
};
export default SvgSelfHost;